<template>
  <b-modal
    ref="modal"
    size="lg"
    title="Upload images"
    class="c-upload-images"
    footer-class="c-upload-images__footer"
    @hide="closeHandler"
  >
    <template #modal-footer>
      <div>
        <b-form-checkbox
          v-model="isRemoveBackground"
          value="true"
          unchecked-value="false"
        >
          Remove background
        </b-form-checkbox>
        <b-form-checkbox
          v-model="isCropToImage"
          value="true"
          unchecked-value="false"
        >
          Crop to image
        </b-form-checkbox>
      </div>

      <div>
        <ButtonOutline
          variant="outline-primary"
          @click="$refs.modal.hide()"
        >
          Cancel
        </ButtonOutline>
        <ButtonPrimary
          variant="primary"
          :disabled="!acceptButtonAvailable"
          @click="accept"
        >
          Upload
        </ButtonPrimary>
      </div>
    </template>

    <b-card>
      <b-card-body>
        <b-form-file
          v-model="files"
          plain
          multiple
        />
        <b-row class="mt-4">
          <b-col v-if="isCompanySelector">
            <label for="company-field">Company</label>
            <b-form-select
              id="company-field"
              v-model="selectedCompany"
            >
              <b-form-select-option
                v-for="company in companies"
                :key="company.id"
                :value="company.id"
              >
                {{ company.name }}
              </b-form-select-option>
            </b-form-select>
          </b-col>
          <b-col>
            <label for="image-type-field">Image Type</label>
            <b-form-select
              id="image-type-field"
              v-model="type"
            >
              <b-form-select-option value="product_image">
                Product Image
              </b-form-select-option>
              <b-form-select-option value="stock_image">
                Stock Image
              </b-form-select-option>
            </b-form-select>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-progress
      v-if="isUploading"
      :value="uploadingProgress"
      show-progress
      animated
    />
  </b-modal>
</template>

<script>
import ButtonPrimary from "../../../common/atoms/ButtonPrimary.vue";
import ButtonOutline from "../../../common/atoms/ButtonOutline.vue";
import mixinModal from "./mixin"
import Requests from "../../../../services/api/file-browser";
import { createNamespacedHelpers } from 'vuex'

const { mapActions } = createNamespacedHelpers('fileBrowser')

export default {
  name: "UploadToTargetModal",
  components: {ButtonOutline, ButtonPrimary},
  mixins: [
    mixinModal
  ],
  data: () => ({
    type: 'product_image',
    selectedCompany: -1,
    files: [],
    isRemoveBackground: false,
    isCropToImage: false,
    isCompanySelector: $('#is-admin').data('value'),
    companies: $('#companies').data('value'),
    uploadingProgress: 0,
    isUploading: false,
  }),
  computed: {
    acceptButtonAvailable() {
      return this.files.length
    },
    currentFolderId() {
      const pathMatch = this.$route?.params?.pathMatch;
      if (pathMatch) {
        const parts = pathMatch.split('/');
        const lastPart = parts[parts.length - 1];
        // Only return if it's a valid number (folder ID)
        if (!isNaN(Number(lastPart)) && lastPart !== '') {
          return lastPart;
        }
      }
      return null;
    }
  },
  watch: {
    '$route': {
      handler() {
        this.$forceUpdate();
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions(['fetchList']),
    async accept() {
      const formData = new FormData;
      for (let i = 0; i < this.files.length; i++) {
        formData.append('upload_images[]', this.files[i]);
      }
      formData.append('image_type', this.type);
      formData.append('company_id', this.selectedCompany);
      formData.append('background_remove', this.isRemoveBackground);
      formData.append('crop_to_image', this.isCropToImage);
      
      // Include folder_id for folder-based uploads
      if (this.currentFolderId) {
        formData.append('folder_id', this.currentFolderId);
      } else {
        console.log('UploadToTargetModal: No folder_id detected, uploading to root folder');
      }

      try {
        this.uploadingProgress = 0;
        this.isUploading = true
        await Requests.uploadProductFile(formData, this.progressHandler.bind(this))
        this.fetchList();
      } catch (error) {
        toastr.error('Something went wrong while importing')
      } finally {
        this.isUploading = false;
        this.close()
      }
    },
    progressHandler(progressEvent) {
      this.uploadingProgress = Math.ceil(progressEvent.loaded / progressEvent.total * 100);
    }
  }
}
</script>

<style scoped lang="scss">
  ::v-deep .c-upload-images {
    &__footer {
      justify-content: space-between;
    }
  }
</style>